module.exports = __webpack_public_path__ + "1d20f70450541d25b9f10159c27d6fed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/oscar-detailed.svg
// module id = 100
// module chunks = 0